
import React, { useEffect, useState } from 'react';

import { useQuery } from 'react-query';
import { smartImportCheckService } from 'services/cv';

import ActionButton from '@core/components/actionbutton/ActionButton';
import Modal from '@core/components/Modal/Modal';
import UseModal from 'hooks/use-modal';
import { MOBILE_SLIDE_UP } from '@core/constants/ModalTypes';
import ImportResume from './ImportResume';

import classes from './ResumeFilled.module.scss';


const ImportNewResumeButton = ({ smart_cv_import_access_status, showGoPremiumModal, toast, refetch }) => {
    const [isImportStarted, setIsImportStarted] = useState(false);
    const [resumeStatus, setResumeStatus] = useState(null);

    const { data: importStatus, refetch: refetchImportStatus } = useQuery('smart-import-status', smartImportCheckService, {
        onSuccess: (data) => {
            setResumeStatus(data?.data?.status);
            if (data?.data?.status === 'saved')
                refetch();
        }
    });

    useEffect(() => {
        let interval;
        if (isImportStarted && (resumeStatus === 'pending' || resumeStatus === 'parsed')) {
            refetchImportStatus(); // immediate check
            interval = setInterval(() => {
                refetchImportStatus();
            }, 10000);
        }
        return () => clearInterval(interval);
    }, [isImportStarted, resumeStatus, refetchImportStatus]);

    const {
        showModal: showUploadResumeModal,
        destroyModal: destroyUploadResumeModal,
        show: showUploadResume
    } = UseModal();

    const onUploadResumeSuccess = () => {
        setIsImportStarted(true);
        refetchImportStatus();
        destroyUploadResumeModal();
    };

    const importClickHandler = () => {
        if (smart_cv_import_access_status === 'subscription_required') {
            showGoPremiumModal();
        }
        else {
            showUploadResumeModal();
        }
    };
    return (
        <>
            <ActionButton kind='secondary_main' disabled={(isImportStarted && (resumeStatus === 'pending' || resumeStatus === 'parsed')) || smart_cv_import_access_status === 'disabled'} onClick={() => importClickHandler()}>Import New CV</ActionButton>
            <Modal isGoPermium={true} header={false} backgroundColor='#fff5e5' type={MOBILE_SLIDE_UP} show={showUploadResume} closeHandler={destroyUploadResumeModal}>
                <ImportResume toast={toast} setResumeStatus={setResumeStatus} onUploadResumeSuccess={onUploadResumeSuccess} />
            </Modal>
        </>
    );
};

export default ImportNewResumeButton;